import React from "react";
import { CAMPUS, Prose } from "@/components/about/AboutSections";

export const AboutPhilosophy = ({ a }) => (
  <section className="relative grain bg-[#0F1B2D] text-white overflow-hidden">
    <div
      className="absolute inset-0 opacity-25"
      style={{
        backgroundImage: `linear-gradient(rgba(15,27,45,0.8), rgba(15,27,45,0.95)), url(${CAMPUS})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-28 text-center">
      <img src="/nc-logo.png" alt="Northcrest" width={72} height={72} className="mx-auto opacity-90" />
      <div className="overline text-[#C4A46A] mt-8">{a.philosophyT}</div>
      <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
        <span className="block">{a.philosophyTagline1}</span>
        <span className="block text-[#C4A46A] font-serif-italic mt-2 text-5xl sm:text-6xl lg:text-7xl">{a.philosophyTagline2}</span>
      </h2>
      <span className="gold-rule mt-10 block mx-auto" />
      <p className="mt-10 mx-auto max-w-3xl text-white/80 text-lg leading-relaxed">{a.philosophyBody}</p>
      <p className="mt-8 font-serif-italic text-[#C4A46A] text-xl">{a.philosophyClose}</p>
    </div>
  </section>
);

const FounderNote = ({ a }) => (
  <div className="mt-20 max-w-3xl" data-testid="founder-note">
    <div className="overline">{a.founderNoteT}</div>
    <h2 className="mt-3 font-display text-3xl lg:text-4xl text-[#0F1B2D] tracking-tight">{a.founderNoteT}</h2>
    <span className="gold-rule mt-6 block" />
    <Prose paras={a.founderNoteParas} className="mt-8 space-y-5 text-[#5E6470] text-lg leading-relaxed" />
    <div className="mt-10" data-testid="founder-signature">
      <p className="font-signature text-[#0F1B2D] text-5xl lg:text-6xl leading-none">André Reis</p>
      <p className="mt-3 overline text-[#5E6470]">Founder · Northcrest Athletics</p>
    </div>
  </div>
);

export const AboutPresence = ({ a }) => (
  <section className="bg-[#F4F0E8]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24">
      <div className="overline">{a.presenceT}</div>
      <h2 className="mt-3 font-display text-4xl lg:text-5xl text-[#0F1B2D] tracking-tight">{a.presenceT}</h2>
      <span className="gold-rule mt-6 block" />
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0F1B2D]/15">
        {a.offices.map((o, i) => (
          <div key={o.city} data-testid={`office-${i}`} className="bg-[#F4F0E8] p-10">
            <div className="font-display text-[#C4A46A]">0{i + 1}</div>
            <h3 className="mt-3 font-display text-2xl text-[#0F1B2D] tracking-tight">{o.city}</h3>
            <div className="text-[#5E6470] mt-1">{o.country}</div>
            <div className="mt-6 overline">{o.role}</div>
          </div>
        ))}
      </div>
      <FounderNote a={a} />
    </div>
  </section>
);
